import { useMemo } from 'react'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import { useIntl } from 'react-intl'

interface Props {
  luxPlusPriceFacets: Array<App.CruiseSearchFacetV2Item>
  hasLuxPlusPrice?: Set<string>
  onChange: (nextFilters: Record<string, any>) => void
}

function CruiseLuxPlusPriceFilter({ luxPlusPriceFacets, hasLuxPlusPrice, onChange }: Props) {
  const intl = useIntl()

  const items = useMemo(() => {
    const facet = luxPlusPriceFacets[0]
    return [{
      value: facet?.slug ?? 'member_prices',
      label: intl.formatMessage({
        id: 'ZAsXpI0jQkx2g5IhkB1A',
        defaultMessage: 'Member prices',
        description: 'Label for the LuxPlus+ member prices filter checkbox in cruise search',
      }),
      count: facet?.count || 0,
    }]
  }, [intl, luxPlusPriceFacets])

  return <FilterPanelCheckboxGroup
    name="hasLuxPlusPrice"
    items={items}
    onChange={onChange}
    defaultSelected={hasLuxPlusPrice}
    maxValue={Number.POSITIVE_INFINITY}
  />
}

export default CruiseLuxPlusPriceFilter
